module.exports = __webpack_public_path__ + "img/Icon_Doc_Estudiante_Hover.284ffe42.svg";